/**
 * True for the Team Apex Branch org (branch account + its agents).
 *
 * Matched by agency id, known staff emails, or an "apex" name so it holds
 * even after an account switch. Used to hide surfaces Apex doesn't use
 * (partner Quick Launch, Template Studio, etc.).
 */
export const APEX_AGENCY_ID = '6a4ead8843cdd7126d88d6f9';
export const APEX_EMAILS = [
    'team.apex@remax.co.za',
    'donna@remaxhomes.co.za',
    'davin@apexhomes.co.za',
];

export function isApexOrg(user) {
    if (!user || typeof user !== 'object') return false;
    const id = String(user._id || user.id || '');
    const agencyId = String(user.agencyId || '');
    const email = String(user.email || '').toLowerCase();
    const name = String(user.name || user.agencyName || '').toLowerCase();
    if (id === APEX_AGENCY_ID || agencyId === APEX_AGENCY_ID) return true;
    if (email && APEX_EMAILS.includes(email)) return true;
    if (name.includes('apex')) return true;
    return false;
}
